import type { StarBridgeState } from '../NumberKingdomState.js';

export interface NumberPathConfig {
  id: string;
  skillId: string;
  start: number;
  target: number;
  jumps: readonly number[];
  maxJumps: number;
  completionBridgeState: StarBridgeState;
}

export const STAR_BRIDGE_NUMBER_PATH_2: NumberPathConfig = {
  id: 'star-bridge-number-path-2',
  skillId: 'math-number-path-addition',
  start: 126,
  target: 148,
  jumps: [10, 1],
  maxJumps: 4,
  completionBridgeState: 'repair-2',
};
